import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { isCronExpressionValid } from 'shared/helpers/Validators';

export default {
  validations() {
    return {
      title: { required },
      dataSourceUrl: { required },
      selectedInbox: { required },
      customRecurrency: {
        required,
        isValidCron: value => isCronExpressionValid(value),
      },
      filters: {
        isNotJson() {
          if (this.filters === '') return true;
          try {
            const parsed = JSON.parse(this.filters);
            if (typeof parsed === 'object') return true;
            return false;
          } catch (error) {
            return false;
          }
        },
      },
      headers: {},
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  computed: {
    isCommonWhatsappConfigInvalid() {
      if (!this.isCommonWhatsappCampaign) return false;
      if (!this.selectedInterval || this.selectedInterval.length !== 2)
        return true;
      if (this.selectedInterval[1] < this.selectedInterval[0]) return true;
      if (
        this.commonWhatsappMessage.parameters.length &&
        this.commonWhatsappMessage.parameters.includes('')
      )
        return false;
      return false;
    },
  },
  methods: {
    additionalInfosData() {
      const data = {};
      if (this.filters) data.filters = JSON.parse(this.filters);
      if (this.headers) data.headers = { auth_token: this.headers };
      if (this.isCommonWhatsappCampaign) {
        data.trigger_rules = {
          minInterval: this.selectedInterval[0],
          maxInterval: this.selectedInterval[1],
        };
        this.messageParams = this.commonWhatsappMessage.parameters.map(e => ({
          param_type: 'origin',
          text: e,
        }));
      }
      data.recurrency = 'custom';
      data.message_params = this.messageParams;
      return data;
    },
    normalizeCronExpression(cron) {
      return cron.toUpperCase().trim().replace(/\s+/g, ' ');
    },
  },
};
